<script>
import Popover from 'element-ui/lib/popover';
export default Popover;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/popover.css';
</style>
